module.exports = __webpack_public_path__ + "static/img/logo.30b41f66.png";